/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./required-indicator.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { R500 } from '@atlaskit/theme/colors';
var requiredIndicatorStyles = null;
export default function RequiredIndicator() {
  return /*#__PURE__*/React.createElement("span", {
    "aria-hidden": true,
    className: ax(["_syaz1ml5 _bozgv77o"]),
    style: {
      "--_1xw92dq": ix("var(--ds-text-danger, ".concat(R500, ")"))
    }
  }, "*");
}